import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=3cc89bed"
import script from "./MenuNav.vue?vue&type=script&lang=js"
export * from "./MenuNav.vue?vue&type=script&lang=js"
import style0 from "./MenuNav.vue?vue&type=style&index=0&id=3cc89bed&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports